import { useTheme } from '@sevenrooms/ui-kit'
import { useMaxWidthBreakpoint } from '@sevenrooms/ui-kit/hooks'
import { Flex, VStack, LogoFooter, Loader } from '@sevenrooms/ui-kit/layout'
import { SkeletonBox } from '../SkeletonBox'
import { WIDGET_CONTAINER_CONTENT_MAX_WIDTH } from './WidgetContainer'

interface WidgetContainerSkeletonProps {
  showGutters?: boolean
}

export function WidgetContainerSkeleton({ showGutters = false }: WidgetContainerSkeletonProps) {
  const { topNav } = useTheme()
  const isMobile = useMaxWidthBreakpoint('s')
  const padding = isMobile ? 'm' : 'lm'
  return (
    <VStack justifyContent="space-between" minHeight="100vh" backgroundColor={showGutters ? 'secondaryBackground' : 'primaryBackground'}>
      <VStack width="100%" flex="1">
        <SkeletonBox height={topNav.height[isMobile ? 'mobile' : 'desktop']} />
        <Flex
          maxWidth={showGutters ? WIDGET_CONTAINER_CONTENT_MAX_WIDTH : undefined}
          width="100%"
          alignSelf="center"
          justifyContent="center"
          alignItems="center"
          pl={padding}
          pr={padding}
          data-test="widget-content"
          flex="1"
          backgroundColor={showGutters ? 'primaryBackground' : undefined}
        >
          <Loader />
        </Flex>
      </VStack>
      <LogoFooter />
    </VStack>
  )
}
